import axios, { AxiosRequestConfig } from 'axios';

export default () => {
  // request interceptor
  axios.interceptors.request.use((config: AxiosRequestConfig) => {
    const authToken = localStorage.getItem('authToken');
    const { headers } = config;
    headers.withCredentials = true;
    headers.credentials = 'include';
    headers.authorization = authToken;
    return config;
  }, (error) => Promise.reject(error));

  // response interceptor
  // axios.interceptors.response.use((response: AxiosResponse) => {
  //   return response;
  // }, (error) => Promise.reject(error));
};
